export default "__VITE_ASSET__EvsEJ$5p6pJFFzCELLx1tA__";